<script setup>
import { watch, computed } from "vue";
import { toast } from "vue3-toastify";
import { usePage } from "@inertiajs/vue3";
import Default from "./Layout/Default.vue";

const page = usePage();

const flash = computed(() => page?.props?.flash);

watch(flash, (newVal) => {
    if (newVal && newVal?.message?.length >= 1) {
        let type = "success";
        if (newVal.element === "flash-error") {
            type = "error";
        }
        toast(newVal.message, {
            type: type,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1000,
        });
    }
});
</script>

<template>
    <div>
        <Default>
            <slot></slot>
        </Default>
    </div>
</template>
